<script lang="ts">
export default {
    name: "SwiperArrow",
};
</script>

<template>
    <svg data-component="swiperArrow"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        class="tiw__icon"
    >
        <path
            opacity="0.5"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30.6673 16.0013C30.6673 7.90113 24.1008 1.33464 16.0007 1.33464C7.90047 1.33464 1.33398 7.90113 1.33398 16.0013C1.33398 24.1015 7.90047 30.668 16.0007 30.668C24.1008 30.668 30.6673 24.1015 30.6673 16.0013ZM15.3731 22.0391C14.9826 22.4297 14.3494 22.4297 13.9589 22.0391C13.5684 21.6486 13.5684 21.0154 13.9589 20.6249L18.5851 15.9987L13.9589 11.3725C13.5684 10.9819 13.5684 10.3488 13.9589 9.95826C14.3494 9.56773 14.9826 9.56773 15.3731 9.95826L20.7065 15.2916C21.097 15.6821 21.097 16.3153 20.7065 16.7058L15.3731 22.0391Z"
            fill="currentColor"
        />
    </svg>
</template>
